interface IIntegrationRemoveModalProps {
  name: string
  category: string
  setShowModal: (show: boolean) => void
  handleRemoveIntegration: () => void
}

function IntegrationRemoveModal(props: IIntegrationRemoveModalProps) {
  const { name, category, setShowModal, handleRemoveIntegration } = props

  return (
    <div className="bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-50" onClick={() => setShowModal(false)}>
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[80%] w-[30%] overflow-y-auto border dark:border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="block">
          <p className="text-2xl font-semibold text-center">Disconnect Integration</p>
          <p className="mt-4 text-center">
            {category == 'SCIM'
              ? `Disconnecting ${name} will keep all current members active, but member management through ${name} will no longer be available.`
              : `Are you sure you want to disconnect ${name}? You will need to reconfigure in the future.`}
          </p>
        </div>

        <div className="flex justify-end mt-6">
          <button
            className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
            onClick={() => {
              setShowModal(false)
            }}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-ErrorRed text-white rounded-lg"
            onClick={() => {
              handleRemoveIntegration()
            }}
          >
            Disconnect
          </button>
        </div>
      </div>
    </div>
  )
}

export default IntegrationRemoveModal
